export const mockBUs = [
  'Aisco AMERICA',
  'Aisco EUROPE',
  'Aisco MENA',
  'Aisco AFRICA',
  'Aisco ANZ',
]
export const mockUsers = [
  'Alice Smith',
  'Bob Johnson',
  'Charlie Davis',
  'Diana Evans',
  'Frank Miller',
]
export const mockCountries = [
  'USA',
  'Mexico',
  'Brazil',
  'Germany',
  'Australia',
  'UAE',
]
export const mockDealers = [
  'AgriCorp',
  'FarmTech',
  'IrrigationPro',
  'WaterSys',
  'GreenFields',
]

export const globalKPIs = {
  totalQuotes: 1245,
  activeQuotes: 432,
  wonQuotes: 580,
  lostQuotes: 185,
  draftQuotes: 48,
  winRate: 75.8,
  lossRate: 24.2,
  activeBUs: 5,
  activeCountries: 24,
  activeDealers: 156,
  variation: {
    total: 12.5,
    won: 8.3,
    winRate: 2.1,
  },
}

export const buComparisonData = [
  {
    name: 'Aisco AMERICA',
    total: 450,
    won: 280,
    lost: 80,
    active: 70,
    draft: 20,
    winRate: 77.7,
  },
  {
    name: 'Aisco EUROPE',
    total: 320,
    won: 150,
    lost: 60,
    active: 100,
    draft: 10,
    winRate: 71.4,
  },
  {
    name: 'Aisco MENA',
    total: 280,
    won: 110,
    lost: 30,
    active: 130,
    draft: 10,
    winRate: 78.5,
  },
  {
    name: 'Aisco AFRICA',
    total: 120,
    won: 30,
    lost: 10,
    active: 75,
    draft: 5,
    winRate: 75.0,
  },
  {
    name: 'Aisco ANZ',
    total: 75,
    won: 10,
    lost: 5,
    active: 57,
    draft: 3,
    winRate: 66.6,
  },
]

export const trendData = [
  { month: 'Jan', total: 85, won: 40, lost: 15, winRate: 72 },
  { month: 'Feb', total: 92, won: 45, lost: 12, winRate: 78 },
  { month: 'Mar', total: 110, won: 55, lost: 18, winRate: 75 },
  { month: 'Apr', total: 105, won: 50, lost: 15, winRate: 76 },
  { month: 'May', total: 125, won: 65, lost: 20, winRate: 76 },
  { month: 'Jun', total: 140, won: 75, lost: 22, winRate: 77 },
  { month: 'Jul', total: 135, won: 70, lost: 18, winRate: 79 },
  { month: 'Aug', total: 150, won: 80, lost: 25, winRate: 76 },
  { month: 'Sep', total: 165, won: 90, lost: 20, winRate: 81 },
  { month: 'Oct', total: 145, won: 75, lost: 15, winRate: 83 },
  { month: 'Nov', total: 130, won: 65, lost: 18, winRate: 78 },
  { month: 'Dec', total: 115, won: 55, lost: 12, winRate: 82 },
]

export const userComparisonData = [
  {
    name: 'Alice Smith',
    total: 120,
    won: 85,
    lost: 15,
    active: 15,
    draft: 5,
    winRate: 85.0,
  },
  {
    name: 'Bob Johnson',
    total: 95,
    won: 60,
    lost: 20,
    active: 10,
    draft: 5,
    winRate: 75.0,
  },
  {
    name: 'Charlie Davis',
    total: 110,
    won: 70,
    lost: 25,
    active: 10,
    draft: 5,
    winRate: 73.6,
  },
  {
    name: 'Diana Evans',
    total: 80,
    won: 45,
    lost: 15,
    active: 15,
    draft: 5,
    winRate: 75.0,
  },
  {
    name: 'Frank Miller',
    total: 45,
    won: 20,
    lost: 5,
    active: 20,
    draft: 0,
    winRate: 80.0,
  },
]

export const countryData = [
  {
    name: 'USA',
    total: 350,
    won: 220,
    lost: 60,
    active: 60,
    draft: 10,
    winRate: 78.5,
  },
  {
    name: 'Mexico',
    total: 210,
    won: 110,
    lost: 40,
    active: 55,
    draft: 5,
    winRate: 73.3,
  },
  {
    name: 'Brazil',
    total: 110,
    won: 40,
    lost: 20,
    active: 45,
    draft: 5,
    winRate: 66.6,
  },
  {
    name: 'Germany',
    total: 150,
    won: 70,
    lost: 15,
    active: 60,
    draft: 5,
    winRate: 82.3,
  },
  {
    name: 'Australia',
    total: 90,
    won: 25,
    lost: 8,
    active: 55,
    draft: 2,
    winRate: 75.7,
  },
]

export const dealerData = [
  {
    name: 'AgriCorp',
    country: 'USA',
    bu: 'North America',
    total: 150,
    won: 95,
    lost: 25,
    active: 25,
    draft: 5,
    winRate: 79.1,
  },
  {
    name: 'FarmTech',
    country: 'Mexico',
    bu: 'LATAM',
    total: 120,
    won: 65,
    lost: 25,
    active: 28,
    draft: 2,
    winRate: 72.2,
  },
  {
    name: 'IrrigationPro',
    country: 'Germany',
    bu: 'Europe',
    total: 95,
    won: 45,
    lost: 10,
    active: 38,
    draft: 2,
    winRate: 81.8,
  },
  {
    name: 'WaterSys',
    country: 'USA',
    bu: 'North America',
    total: 85,
    won: 55,
    lost: 15,
    active: 12,
    draft: 3,
    winRate: 78.5,
  },
  {
    name: 'GreenFields',
    country: 'Brazil',
    bu: 'LATAM',
    total: 65,
    won: 25,
    lost: 12,
    active: 25,
    draft: 3,
    winRate: 67.5,
  },
]

export const quotesListData = [
  {
    id: 'QT-2026-001',
    date: '2026-04-15',
    update: '2026-04-18',
    status: 'Won',
    country: 'USA',
    dealer: 'AgriCorp',
    bu: 'North America',
    user: 'Alice Smith',
    amount: 45000,
  },
  {
    id: 'QT-2026-002',
    date: '2026-04-14',
    update: '2026-04-19',
    status: 'Active',
    country: 'Mexico',
    dealer: 'FarmTech',
    bu: 'LATAM',
    user: 'Bob Johnson',
    amount: 32000,
  },
  {
    id: 'QT-2026-003',
    date: '2026-04-12',
    update: '2026-04-15',
    status: 'Lost',
    country: 'Germany',
    dealer: 'IrrigationPro',
    bu: 'Europe',
    user: 'Charlie Davis',
    amount: 18500,
  },
  {
    id: 'QT-2026-004',
    date: '2026-04-10',
    update: '2026-04-11',
    status: 'Won',
    country: 'Brazil',
    dealer: 'GreenFields',
    bu: 'LATAM',
    user: 'Diana Evans',
    amount: 55000,
  },
  {
    id: 'QT-2026-005',
    date: '2026-04-08',
    update: '2026-04-08',
    status: 'Draft',
    country: 'USA',
    dealer: 'WaterSys',
    bu: 'North America',
    user: 'Frank Miller',
    amount: 12000,
  },
  {
    id: 'QT-2026-006',
    date: '2026-04-05',
    update: '2026-04-12',
    status: 'Won',
    country: 'Australia',
    dealer: 'AgriCorp',
    bu: 'APAC',
    user: 'Alice Smith',
    amount: 85000,
  },
  {
    id: 'QT-2026-007',
    date: '2026-04-01',
    update: '2026-04-10',
    status: 'Active',
    country: 'UAE',
    dealer: 'WaterSys',
    bu: 'Middle East',
    user: 'Bob Johnson',
    amount: 125000,
  },
]

export const globalInsights = [
  {
    id: 1,
    text: 'North America is the top performing Business Unit with 280 Won Quotes.',
    type: 'positive',
  },
  {
    id: 2,
    text: 'Europe has the highest Win Rate at 78.5%.',
    type: 'positive',
  },
  {
    id: 3,
    text: 'Lost quotes in LATAM increased by 12% compared to last quarter.',
    type: 'negative',
  },
  {
    id: 4,
    text: 'Overall Win Rate improved by 2.1% year-over-year.',
    type: 'positive',
  },
]

export const buInsights = [
  {
    id: 1,
    text: 'Alice Smith is the top performer with 85 Won Quotes.',
    type: 'positive',
  },
  {
    id: 2,
    text: 'FarmTech is the most active dealer in this region.',
    type: 'neutral',
  },
  {
    id: 3,
    text: 'Active quotes pipeline is 30% higher than same time last year.',
    type: 'positive',
  },
]

export const userInsights = [
  {
    id: 1,
    text: 'Your Win Rate is 9.2% above the regional average.',
    type: 'positive',
  },
  {
    id: 2,
    text: 'You have 15 Active quotes pending follow-up.',
    type: 'warning',
  },
  {
    id: 3,
    text: 'Most of your Won quotes are concentrated in the USA.',
    type: 'neutral',
  },
]
